<template>
    <div class="bg d-flex align-items-center justify-content-center">
        <div class="glass m-2">
            <form class="p-2 d-flex flex-column align-items-center text-center"
                  @submit.stop.prevent="login">
                <h4 class="mb-3">
                    Pro vstup zadejte příjmení závodníka, který vyhrál většinu ročníků triatlonu
                </h4>
                <div v-if="error" class="error mb-2">
                    {{error}}
                </div>
                <input v-model="surname" autofocus="autofocus" class="form-control" style="width: auto"/>
                <button type="submit" class="btn btn-warning my-3">Vstoupit</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                surname: "",
                error: ""
            };
        },
        watch: {
            surname() {
                this.error = "";
            },
        },
        methods: {
            login() {
                this.error = "";
                this.$gtag.event("login", { label: this.surname });
                this.$store.dispatch("login", {password: this.surname})
                    .then(() => this.$router.replace(this.$route.query.target || "/"))
                    .catch(() => this.error = "Nesprávné vstupní heslo");
            }
        }
    };
</script>

<style scoped lang="scss">
    .glass {
        width: 30rem;
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, .2);
        border-radius: 5px;
        background-color: rgba(255, 255, 255, .20);
        color: white;

        backdrop-filter: blur(10px);
        z-index: 999;
    }

    .error {
        color: var(--danger);
        font-weight: bold;
        font-size: 1.1rem;
    }

    .bg {
        /* The image used */
        background-image: url("/img/background.jpg");

        /* Full height */
        height: 100%;

        /* Center and scale the image nicely */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>